import { isSafeRegex } from 'commonUtils/safeRegex';

type GeneratePageRouteOptions = {
  patternTransformer?: (pageUrl: string) => string;
};

// Добавляет к базовому пути возможность иметь ещё только один вложенный сегмент
export const withSingleNestedSegment = (pageUrl: string) => `(?:${pageUrl}|${pageUrl}/[^/]+)`;

export const generatePageRoute = (pageUrl = '', options?: GeneratePageRouteOptions) => {
  const normalizedPageUrl = options?.patternTransformer ? options.patternTransformer(pageUrl) : pageUrl;

  const pattern = `^${normalizedPageUrl}/?$`;

  if (!isSafeRegex(pattern)) {
    throw new Error(`Unsafe route regex detected,  pageUrl=${pageUrl}, pattern=${pattern}`);
  }

  return new RegExp(pattern);
};
